import Image from 'next/future/image';
import { storeDetails } from './constants';
import settings from '@/settings';
import tickBlackIcon from '@/public/icons/reebelocare/tick_black.svg';

const Details = () => {
  const generateContent = () =>
    storeDetails[settings.store] ?? storeDetails.default;

  const content = generateContent();

  return (
    <div className="mt-3 flex flex-col gap-y-1">
      {content.map((item) => (
        <div className="flex gap-1" key={item}>
          <div className="mt-0.5 h-2.5 w-2.5 shrink-0">
            <Image
              src={tickBlackIcon}
              alt="Tick"
              width={15}
              height={15}
              className="h-full w-full object-contain"
            />
          </div>

          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: item }}
          />
        </div>
      ))}
    </div>
  );
};

export default Details;
